import styled from "styled-components";
export const DocumentListWrapper = styled.div`
  .cell-document-name {
    min-width: 400px;
  }
  .cell-geo-scope {
    min-width: 166px;
  }
  .cell-expirationDate {
    min-width: 174px;
  }
  .cell-exclusivity {
    min-width: 174px;
  }
  .cell-status {
    min-width: 124px;
  }
  .badge-status {
    white-space: nowrap;
  }
  .MuiPickersTextField-root {
    width: 100%;
  }
  .MuiPickersInputBase-root {
    width: 100%;
  }
  .document-name-link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
